const rmvSpaceAndSpecial = (str: string) => str.replace(/[^A-Z0-9]+/gi, '');

export default rmvSpaceAndSpecial;
